import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';

/**
 * small colored dot + label used in the oep status legend. when `count` is
 * given it renders before the label, and zero counts are dimmed.
 * @param className - tailwind classes controlling the dot color
 * @param label - text shown next to the dot
 * @param count - optional number of items with this status
 */
export default function StatusLegendDot({ className, label, count }) {
  const hasCount = typeof count === 'number';

  return (
    <span
      className={cn(
        'flex items-center gap-1.5',
        hasCount && count === 0 && 'opacity-50'
      )}
    >
      <span
        className={cn('inline-block size-2 shrink-0 rounded-full', className)}
      />
      {hasCount && <span className='font-semibold text-gray-800'>{count}</span>}
      <span>{label}</span>
    </span>
  );
}

StatusLegendDot.propTypes = {
  className: propTypes.string.isRequired,
  label: propTypes.string.isRequired,
  count: propTypes.number
};
